import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Client } from "../../api-client";
import {
  API_ADD_FOREX,
  API_COMMON_GET_BY_MODULE,
  API_GET_FOREX_LIST,
  API_UPDATE_FOREX,
} from "../../../shared/routes/private.routes";
import { TABLE_ROWS_COUNT } from "../../../shared/constants";
const config = {
  name: "master",
};

export const requestGetByModuleCommon: any = createAsyncThunk(
  `${config.name}/requestGetByModule`,
  async ({ module }: { module: string }) => {
    const response = await Client.get(API_COMMON_GET_BY_MODULE(module));
    return response.data;
  }
);

export const getForexList: any = createAsyncThunk(
  `${config.name}/getForexList`,
  async ({ params, body }: any) => {
    const response = await Client.post(API_GET_FOREX_LIST, body, { params });
    return response.data;
  }
);

export const addForex: any = createAsyncThunk(
  `${config.name}/add-forex`,
  async (body: any) => {
    return Client.post(API_ADD_FOREX, body);
  }
);

export const updateForexDetails: any = createAsyncThunk(
  `${config.name}/update-forex`,
  async ({ id, body }: { id: string; body: any }) => {
    const url = API_UPDATE_FOREX + `${id}`;
    return Client.put(url, body);
  }
);

export const masterReducer = createSlice({
  name: config.name,
  initialState: {
    loadingForex: false as any,
    forexList: [] as any,
    filters: {} as any,
    pagination: { page: 0, limit: TABLE_ROWS_COUNT, total: 0 },
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getForexList.pending, (state) => {
        state.loadingForex = true;
        state.forexList = [] as any;
      })
      .addCase(getForexList.fulfilled, (state, action) => {
        state.loadingForex = false;
        state.forexList = action?.payload?.data;
        state.pagination = {
          page: action?.payload?.page,
          limit: action?.payload?.limit,
          total: action?.payload?.total,
        };
      })
      .addCase(getForexList.rejected, (state) => {
        state.loadingForex = false;
        state.forexList = [] as any;
      });
  },
});

export default masterReducer.reducer;
